import React, { useEffect, useState } from 'react';

import { useInfiniteQuery } from '@tanstack/react-query';

import { getNotificationInfiniteQueryOptions } from '@query';

import { NOTIFICATION_STATUS } from '@api';

import { useSocket } from '@shared/common/providers/socket';

import { Actions } from '@ui/uikit/components/icons/mono/Actions';

import { useNavLayout } from './NavLayout';
import { Notifications } from './Notifications';

const NotificationsButton = () => {
  const { socket } = useSocket();

  const { user } = useNavLayout();
  const [isOpen, setIsOpen] = useState(false);
  const { data: hasUnreadNotification, refetch } = useInfiniteQuery({
    // NOTE: the same query options because logic for marking
    // notifications is implemented for the key that used inside it
    ...getNotificationInfiniteQueryOptions(),
    select: (data) =>
      data.pages.some((page) =>
        page.rows.some((notification) => notification.status === NOTIFICATION_STATUS.NEW),
      ),
    enabled: !!user?.data.id,
  });

  useEffect(() => {
    if (!socket) {
      return;
    }

    socket.on('notifications.update', () => {
      refetch();
    });

    return () => {
      socket.off('notifications.update');
    };
  }, [socket]);

  return (
    <>
      <button
        onClick={() => setIsOpen(true)}
        className="msq-btn msq-btn-icon-md msq-btn-ghost size-[2.25rem] text-base-text-primary md-msq:msq-btn-icon-lg"
      >
        <Actions className="msq-btn-icon-child-md" />
        {hasUnreadNotification && (
          <span className="size-2.5 md-msq:size-3 border-2 border-base-bg rounded-full bg-palette-pink-52 absolute top-0 right-0" />
        )}
      </button>

      <Notifications open={isOpen} onOpenChange={setIsOpen} />
    </>
  );
};

export default NotificationsButton;
